import { render, staticRenderFns } from "./uButton.vue?vue&type=template&id=53be15db&scoped=true&"
import script from "./uButton.vue?vue&type=script&lang=js&"
export * from "./uButton.vue?vue&type=script&lang=js&"
import style0 from "./uButton.vue?vue&type=style&index=0&id=53be15db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53be15db",
  null
  
)

export default component.exports